import React, { useEffect, useRef } from 'react';
import { View, ScrollView } from 'react-native';
import ScreenWrapper from '../../components/ScreenWrapper/ScreenWrapper';
import withAuth from '../../auth/withAuth';
import PolicyDropdown from '../../components/PolicyDropdown';
import Breadcrumbs from '../../components/Breadcrumbs';
import { trackPage } from '../../utils/Analytics/AdobeAnalyticsUtils';
import { analyticsTags } from '../../utils/Analytics/AnalyticsTags';
import BillingAndPremium from './components/BillingAndPremium';
import RecentTransactionHistory from './components/RecentTransactionHistory';
import LoanInformation from './components/LoanInformation';
import { usePolicyFinancialsSelector } from './hooks/policyFinancials';

const PolicyFinancials = (props) => {
  const scrollViewRef = useRef<ScrollView>(null);
  const billingAndPremiumRef = useRef(null);
  const LoansRef = useRef(null);
  const recentTransactionHistoryRef = useRef(null);

  const {
    billingAndPremiumData,
    account,
    policyNumber,
    policyLoanData,
    loanHighlightedData,
    loansAsOfDate,
    allowFinancialActivities,
  } = usePolicyFinancialsSelector();

  useEffect(() => {
    trackPage(analyticsTags.createPolicyFinancialsViewTags);
    if (props?.route?.params?.target === 'RecentTransactionHistory') {
      scrollToView(recentTransactionHistoryRef);
    } else if (props?.route?.params?.target === 'LoansInformation') {
      scrollToView(LoansRef);
    } else {
      scrollViewRef?.current?.scrollTo({ y: 0, animated: true });
    }
  }, [props?.route?.params]);

  const scrollToView = (ref) => {
    ref?.current?.measureLayout(null, (x, y, width, height) => {
      scrollViewRef?.current?.scrollTo({ y: y, animated: true });
    });
  };

  return (
    <ScreenWrapper
      scrollFooter
      paddingTop
      paddingBottom
      paddingHorizontal
      ref={scrollViewRef}
    >
      <Breadcrumbs />
      <PolicyDropdown
        className={''}
        accessToken={props.accessToken}
        text={'Policy Financials'}
      />
      {billingAndPremiumData.length > 0 && (
        <View ref={billingAndPremiumRef}>
          <BillingAndPremium
            billingAndPremiumData={billingAndPremiumData}
            accessToken={props.accessToken}
            policyNumber={policyNumber}
            account={account}
          />
        </View>
      )}

      <View ref={LoansRef}>
        <LoanInformation
          policyLoanData={policyLoanData}
          loanHighlightedData={loanHighlightedData}
          loansAsOfDate={loansAsOfDate}
        />
      </View>

      {allowFinancialActivities && (
        <View ref={recentTransactionHistoryRef}>
          <RecentTransactionHistory />
        </View>
      )}
    </ScreenWrapper>
  );
};

export default withAuth(PolicyFinancials);
